<template>
    <span
        class="mr-2"
        :class="{
            'chip-emerald': status == 0,
            'chip-rose': status == 1,
            'chip-amber': status != 0 && status != 1,
        }"
    >
        {{ statusName }}
    </span>
</template>

<script>
export default {
    props: ["status"],

    computed: {
        statusName() {
            switch (this.status) {
                case 1:
                case true:
                    return "Recebimento no fluxo";
                case 0:
                case false:
                    return "Recebimento total";
                default:
                    return this.status;
            }
        },
    },
};
</script>
